angular
.module( 'ribytRsvpApp' )
.directive( 'hotelByt', function ( $sessionStorage, $sce, $http, ENV, $rootScope ) {
    return {
        'restrict': 'E',
        'scope': {
            'currentByt': '@',
            'isTimeFormat24': '@'
        },
        'templateUrl': 'views/directives/itinerary/hotelByt.html',
        'link': function ( scope, element, attrs ) {
            var byt = JSON.parse( scope.currentByt );
            var newByt = {};
            scope.trustedHtml = function (plainText) {
                return $sce.trustAsHtml(plainText);
            };
            scope.preview = $rootScope.preview;

            scope.isAccepted = function ( passedByt ) {
                var data = {
                    bytID: passedByt.bytID.id,
                    status: passedByt.isAccepted
                };
                $http.put( ENV.apiEndpoint + '/ribyt/rsvp/setBytStatus/' + $sessionStorage.inviteHash, data )
                    .then( function setBytStatus ( ) {
                        // update the invite session storage/scope just in case they refresh
                        var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );
                        // find the byt in the invite
                        var modifiedBytIndex = _.findIndex( _.get( invitation, 'byts' ), {'bytID.id': _.get( passedByt, 'bytID.id' )} );

                        // set the isAccepted value to the invite
                        _.set( invitation, 'byts[' + modifiedBytIndex + '].isAccepted', passedByt.isAccepted );
                        // save the results in $sessionStorage
                        _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invitation ) );
                    }, function setBytStatusError ( error ) {
                    } );
            };

            _.each( byt, function ( b, key ) {
                newByt[key] = b;
            } );
            scope.byt = newByt;

            // remove any offset - RPT-2330
            removeDatetimeCheckInOutOffset( scope.byt );

            scope.pdfView = _.get( $sessionStorage, 'pdfView', false );
            var addressInfo = ['address', 'locality', 'region', 'postcode'];
            scope.location = [];

            var hasAddress = false;
                // setup the location information in an array so we can read it easier on the FE
            _.forEach( addressInfo, function ( address ) {
                var addComma = ',';
                if ( address === 'postcode' || address === 'region' ) {
                    addComma = '';
                }

                var bytAddressType = _.trim( _.get( scope, 'byt.bytID.locationData.' + address, '' ) );

                if ( bytAddressType && bytAddressType !== '' ) {
                    scope.location.push( bytAddressType + addComma );
                    hasAddress = true;
                }
            } );

                // display TBD if the hotel location has not been setup yet
                    // removed per rpt-2360
            if ( hasAddress ) {
                scope.location = scope.location.join( ' ' );
            } else {
                scope.location = '';
            }

            function removeDatetimeCheckInOutOffset ( byt ) {
                if ( _.has( byt, 'bytDetails.datetimeCheckIn' ) ) {
                    byt.bytDetails.datetimeCheckIn = moment( byt.bytDetails.datetimeCheckIn ).format( 'YYYY-MM-DD HH:mm:ss' );
                }
                if ( _.has( byt, 'bytDetails.datetimeCheckOut' ) ) {
                    byt.bytDetails.datetimeCheckOut = moment( byt.bytDetails.datetimeCheckOut ).format( 'YYYY-MM-DD HH:mm:ss' );
                }
            }
        }
    };
} );
